import { CustomLibary } from "@/shared";

export const FloorPlanEvents = {
  ElementMouseOver: new CustomLibary.Event<void>()
};